import { render, staticRenderFns } from "./CompanyRegister.vue?vue&type=template&id=64748c8c&scoped=true&"
import script from "./CompanyRegister.vue?vue&type=script&lang=ts&"
export * from "./CompanyRegister.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyRegister.vue?vue&type=style&index=0&id=64748c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64748c8c",
  null
  
)

export default component.exports